function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["label", "icon", "href", "size", "iconSize", "role", "color", "onClick", "disabled", "extend"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import Click from '../click';
import Box from '../box';
import useIconLink from '../../hooks/useIconLink.js';
var defaultButtonStyle = function defaultButtonStyle(_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  return {
    cursor: 'pointer',
    background: 'transparent',
    padding: 0,
    border: 0,
    width: size,
    height: size,
    font: 'inherit',
    ':focus': {
      outline: 0,
      boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.colors.focusColor,
      ':not(:focus-visible)': {
        boxShadow: 'none'
      }
    }
  };
};
var linkStyle = function linkStyle(_ref2) {
  var size = _ref2.size;
  return {
    textDecoration: 'none',
    display: 'flex',
    color: 'inherit',
    width: size,
    height: size,
    alignItems: 'center',
    justifyContent: 'center'
  };
};
var IconButton = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var label = _ref3.label,
    Icon = _ref3.icon,
    href = _ref3.href,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? [48,,, 40] : _ref3$size,
    _ref3$iconSize = _ref3.iconSize,
    iconSize = _ref3$iconSize === void 0 ? 16 : _ref3$iconSize,
    _ref3$role = _ref3.role,
    role = _ref3$role === void 0 ? 'presentation' : _ref3$role,
    _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'foreground.primary' : _ref3$color,
    onClick = _ref3.onClick,
    disabled = _ref3.disabled,
    extend = _ref3.extend,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _useFela = useFela(),
    theme = _useFela.theme;
  var _useIconLink = useIconLink(label, href),
    linkProps = _useIconLink.linkProps,
    iconProps = _useIconLink.iconProps,
    labelEl = _useIconLink.label;
  var styleProps = {
    size: size,
    theme: theme
  };
  var icon = /*#__PURE__*/React.createElement(Icon, _extends({
    size: iconSize,
    color: color
  }, iconProps));
  if (href) {
    return /*#__PURE__*/React.createElement(Click, _extends({}, props, linkProps, {
      ref: ref,
      href: href,
      disabled: disabled,
      extend: _objectSpread(_objectSpread({}, linkStyle(styleProps)), extend)
    }), icon, labelEl);
  }
  return /*#__PURE__*/React.createElement(Click, _extends({}, props, {
    ref: ref,
    onClick: onClick,
    disabled: disabled,
    extend: _objectSpread(_objectSpread({}, defaultButtonStyle(styleProps)), extend)
  }), /*#__PURE__*/React.createElement(Box, {
    extend: {
      alignItems: 'center',
      justifyContent: 'center'
    }
    // maybe this should be aria-label? Ask kitty
    ,
    title: label,
    role: role
  }, icon, labelEl));
});
export default IconButton;
IconButton.displayName = 'IconButton';
IconButton.propTypes = {
  size: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  iconSize: PropTypes.number,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  label: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  role: PropTypes.string,
  onClick: PropTypes.func,
  /** Additional styles, use with caution */
  extend: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array])
};